import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { motion } from "framer-motion"
import Naviburger from "@elements/Naviburger"
import { useLocation } from "@reach/router"
import tw, { styled } from "twin.macro"
import { useStateContext } from "@context/stateContext"

const bgVariants = {
  closed: {
    x: "100%",
    transition: {
      type: "spring",
      bounce: 0,
      duration: 0.4,
    },
  },
  open: {
    x: 0,
    transition: {
      type: "spring",
      bounce: 0,
      duration: 0.4,
      staggerChildren: 0.05,
    },
  },
}


function MobileNavigation({ menuItems, className }) {
  const location = useLocation()
  const locationPathName = location.pathname
  // const [open, setOpen] = useState(false)

  const { mobileMenuOpen, openMobileMenu, closeMobileMenu } = useStateContext()

  useEffect(() => {
    closeMobileMenu()
  }, [location]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (mobileMenuOpen) {
      document.documentElement.style.overflow = "hidden"
    } else {
      document.documentElement.style.overflow = "hidden auto"
    }
  }, [mobileMenuOpen])

  return (
    <>
      <Nav
        initial={bgVariants.closed}
        variants={bgVariants}
        animate={mobileMenuOpen ? "open" : "closed"}
        className={`w-screen absolute bg-white top-0 left-0 overflow-x-hidden overflow-y-hidden`}
      >
        <div
          className={`mt-24 pt-c45 pb-24 w-full h-full relative`}
        >
          <NavStaticWrapper
            className={`overflow-y-auto px-c30 h-full`}
          >
            <ul className="block">
              {menuItems.map(({ id, label, path, parentId, acfMegaMenu }) => (
            
                <MenuItem
                  key={id}
                  label={label}
                  acfMegaMenu={acfMegaMenu}
                  path={path}
                  locationPathName={locationPathName}
                  level={0}
                  
                ></MenuItem>
              ))}
            </ul>
          </NavStaticWrapper>
        </div>
      </Nav>
      <Naviburger
        className={`relative z-10 ml-auto`}
        menuOpen={mobileMenuOpen}
        onClick={e => (mobileMenuOpen ? closeMobileMenu() : openMobileMenu())}
      />
    </>
  )
}

export default MobileNavigation


const MenuItem = ({
  id,
  label,
  path,
  acfMegaMenu,
  parentOpen,
  level,
  locationPathName,
}) => {
  const [open, setOpen] = useState(false)
  const toggleOpenMob = clickEvent => {
    setOpen(!open)
    clickEvent.stopPropagation()
  }
  return (
    <MenuListItem
      level={level}
      active={path === locationPathName}
      className="static"
    

    >
      { acfMegaMenu && acfMegaMenu.columns == null && 
      <Link className={``} to={path} title={label} aria-label={label}>
        {label}
      </Link>
      }
       { acfMegaMenu && acfMegaMenu.columns != null && 
      <button className={`open-${open}`}  title={label} aria-label={label}  onClick={clickEvent => {
        toggleOpenMob(clickEvent)
      }}
      >
        {label}
      </button>
      }
     
      { acfMegaMenu && acfMegaMenu.columns != null && <SubMenu
         className={`level-${level}`}
         id={id}
         label={label}
         path={path}
         setOpen={setOpen}
         acfMegaMenu={acfMegaMenu.columns}
         parentOpen={open}
         level={level}
         locationPathName={locationPathName}
      />
      }

    </MenuListItem>
  )
}

function SubMenu({
  id,
  label,
  path,
  acfMegaMenu,
  parentOpen,
  setOpen,
  level,
  locationPathName,
}) {
  // const [open, setOpen] = useState(false)
  const toggleOpenMob = clickEvent => {
    setOpen(!parentOpen)
    clickEvent.stopPropagation()
  }
  const newLevel = level + 1
  const openClass = parentOpen ? "left-0 visible" : ' left-p110  invisible';

  return (
    <>
    <div class={`submenu-wrapper absolute transition-all px-c30 z-20 pb-6 -top-2.5 pt-c45 duration-200 bg-white w-full overflow-y-auto ${openClass}`}>
      <button class="submenu-back-button" aria-label={`Close ${label} submenu.`} onClick={clickEvent => {toggleOpenMob(clickEvent) }}>{label}</button>
      <ul className="submenu-1">
    
        
        {acfMegaMenu.map((items) => (
          <SubMenuItem
            key={id}
            newLevel={newLevel}
            items={items}
            level={newLevel}
            locationPathName={locationPathName}
          ></SubMenuItem>
        ))}
     
      </ul>
    </div>
    
    </>
  )
}

const SubMenuItem = ({
  id,
  label,
  path,
  items,
  parentOpen,
  level,
  locationPathName,
}) => {
  const newLevel = level + 1;
  return (
    <>
    { items.items.map(({ menuItem, menuTitle, subitems }) => {
        return(
          
          <MenuListItem level={level} className={`level-${level}`} active={menuItem.link === locationPathName}> 
            { menuTitle != null && <h3 class={`level-${level} menu-title`}>
              {menuTitle}
            </h3>
            }
            <Link className={``} to={menuItem.link} title={menuItem.title} aria-label={menuItem.title}>
            {menuItem.title}
            </Link>

            { subitems!= null && <SubMenuSecond
              className={`level-${level}`}
              subitems={subitems}
              parentOpen={parentOpen ? parentOpen : "noParrent"}
              level={newLevel}
              locationPathName={locationPathName}
            />
          }
          </MenuListItem>
        )
         
      })}
    </>
 
  )
}
function SubMenuSecond({
  id,
  label,
  path,
  subitems,
  level,
  locationPathName,
  parentOpen,
  parentRef,
  setClosedAll,
  closedAll,
}) {
 

  return (
    <>
    <ul className="submenu-second">
      {subitems.map((subitem) => {
        return (
          <MenuListItem className={`level-${level}`}  level={level} active={subitem.submenuItem.link === locationPathName}>
            <Link className={``} to={subitem.submenuItem.link} title={subitem.submenuItem.title} aria-label={subitem.submenuItem.title}>
              {subitem.submenuItem.title}
            </Link>
          </MenuListItem>
        );
      })}
      </ul>
    </>
  );
}



const NavStaticWrapper = styled.div`


` 

const Nav = styled(motion.nav)`
  height: calc(100vh - 30px);
  @supports (height:100dvh) {
    height: calc(100dvh - 30px);
  }
  overflow: hidden;
  
` 
// &:has(button.open-true) {
//   overflow-y: hidden;
// }
// &:not(:has(button.open-true)) {
//   overflow-y: auto;
// }
const MenuListItem = motion(
  styled.li(({ level, active }) => {
    switch (level) {
      case 0:
        return [
          { textDecoration: active ? "underline" : "none" },
          tw`
            font-ubuntu
            cursor-pointer
            border-grey
            border-b
            last:border-none
            `,
          `> a, > button{`,
            tw`text-black block font-bold text-24 text-left uppercase no-underline hover:no-underline pt-c45 pb-c45 w-full tracking-bigWide`,
             { textDecoration: active ? "underline" : "none" },
          `}`,
          `
         
          > button {
            position: relative;
            &:after {
              content: '';
              background-image: url("data:image/svg+xml,%3Csvg width='11' height='21' viewBox='0 0 11 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 19.5L10 10.5L2 1.5' stroke='black' stroke-width='2' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
              `,
            tw`absolute top-1/2 transform -translate-y-1/2 right-0 bg-contain bg-no-repeat h-18px w-2.5`,
            `}
          }
          &:first-of-type {
            > a, > button {
              padding-top:0;
            }
            > button {
              &:after {
                top:4px;
                transform:translateY(0);
              }
            }

          }
          .submenu-wrapper{
            height: calc(100vh - 116px);
            @supports (height:100dvh) {
              height: calc(100dvh - 116px);
            }
          }
          .submenu-wrapper  .submenu-back-button {`,
            tw`text-black font-bold text-24 uppercase no-underline hover:no-underline mb-5 relative px-8 py-2`, 
          ` &:after {
            content: '';
            background-image: url("data:image/svg+xml,%3Csvg width='11' height='21' viewBox='0 0 11 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1.5L1 10.5L9 19.5' stroke='black' stroke-width='2' stroke-linecap='square' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
             `,
            tw`absolute top-1/2 transform -translate-y-1/2 left-0 bg-contain bg-no-repeat h-18px w-2.5`,
            `}
          }`,
        ]
      case 1:
        return [
         
          tw`
          font-ubuntu pb-c36 pt-c36 first-of-type:pt-0 border-b border-grey/80 last-of-type:border-none
          `,
          `> a, > button{`,
            tw`text-black font-bold text-20 normal-case no-underline hover:no-underline block`,
            { textDecoration: active ? "underline" : "none" },
          `}
          &:has(.submenu-second) > a, &:has(.submenu-second) > button {
            margin-bottom: 16px;
          }
          &:has(.level-1.menu-title){
            .menu-title {
              `,
                tw`font-bold text-20 normal-case pb-4 block`,
              `
            }
            > a{
              `,
                tw`font-light text-16 normal-case pb-3 block mb-0`,
              `
            }
          }`
        ]
      case 2:
        return [
        
          tw`
            font-ubuntu pb-3 last-of-type:pb-0
          `,
          `> a, > button{`,
            tw`text-black font-light text-16 normal-case no-underline hover:no-underline`,
              { textDecoration: active ? "underline" : "none" },
          `}`
        ]
      default:
        return [
          { textDecoration: active ? "underline" : "none" },
          tw`
            font-ubuntu
            cursor-pointer
            text-black
            font-bold
            text-3xl xs:text-5xl sm:text-6xl
            border-t-2 xs:border-t-4
            last:border-b-2 xs:last:border-b-4
            py-4
            `,
        ]
    }
  })
)
